import { useSelectTheme } from "../../../store/state/theme";
import { defaultSvgProps, SvgProps } from "../type/props";

export const SkipIcon = (props?: SvgProps) => {
  const { color } = useSelectTheme();
  const { width, height, fill, style } = defaultSvgProps(props, {
    width: 20,
    height: 20,
    fill: color.black,
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.832 12.4987L10.832 17.4987L9.6487 16.3154L12.6404 13.332H3.33203V3.33203H4.9987V11.6654H12.6404L9.6487 8.68203L10.832 7.4987L15.832 12.4987Z"
        fill={fill}
      />
    </svg>
  );
};
